'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchOneTest (token) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/spec-public/schlum/test/${token}`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  uploadPicturePublic (token, {picture}) {
    return new Promise((resolve, reject) => {
      const data = new FormData()
      data.append('picture', picture)

      Axios.post(`/1.0/spec-public/schlum/create-response-picture/${token}`, data)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  retrieveVideoInterviewPublic (token) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/spec-public/schlum/video_interviews/${token}`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  }
}
